import { Component, OnInit } from '@angular/core';
import { AuthService } from '@app/@core/services/auth.service';
import { PermissionStore } from '@app/@core/store/permission.store';
import { environment } from '@env/environment';
import { BehaviorSubject, Subscription } from 'rxjs';
import { HttpService } from '@app/@core/services/http.service';
import { AppConstants } from '@app/@core/entities/app-constants';
import { LocalService } from '@core/services/local.service';

@Component({
  standalone: false,
  selector: 'app-permissions',
  templateUrl: './permissions.component.html',
  styleUrls: ['./permissions.component.scss']
})

export class PermissionsComponent implements OnInit {
  RBACORG: any;
  PERMISSION: any;
  orgSubs: Subscription;
  permissionEvent$: BehaviorSubject<any>;
  COMMONSERVICE!: BehaviorSubject<any>;
  INPUTVALIDATIONMETHOD: any;

  constructor(private permissionStore: PermissionStore, private authService: AuthService, private httpService: HttpService, private sessionStorage: LocalService) {
    this.COMMONSERVICE = new BehaviorSubject<any>(null);
    this.permissionEvent$ = new BehaviorSubject<any>(null);
    this.orgSubs = this.authService.orgInfo.subscribe(o => {
      console.log('PermissionsComponent');
      this.INPUTVALIDATIONMETHOD = AppConstants.onInput.bind(this);
      this.PERMISSION = this.permissionStore.state;
      this.RBACORG = {
        tokenKey: 'jwt-token',
        apiHost: environment.apiHost,
        others: this.sessionStorage.asStorage(),
        orgID: o ? o : this.sessionStorage.getItem('orgid'),
        environment: {
          mstrUsername: environment.mstrUsername,
          mstrPassword: environment.mstrPassword,
          mstrURL: environment.mstrURL,
          mstrProjectID: environment.mstrProjectID,
          applicationid: environment.applicationid,
          priority: environment.priority,
          videoConferenceDomain: environment.videoConferenceDomain,
          ChatBotNew: environment.ChatBotNew,
          ChatBot: environment.ChatBot,
          n8nWorflowUrl: environment.n8nWorflowUrl,
          production: environment.production
        }
      };
      this.permissionEvent$.next({
        RBACORG: this.RBACORG,
        PERMISSION: this.PERMISSION,
        httpService: this.httpService,
        INPUTVALIDATIONMETHOD: this.INPUTVALIDATIONMETHOD
      });
    });
  }

  ngOnInit(): void {
    console.log();
  }
  // eslint-disable-next-line @angular-eslint/use-lifecycle-interface
  ngOnDestroy(): void {
    this.orgSubs.unsubscribe();
  }
}
